import { AnimationEvent } from '@angular/animations';
import {
  AfterViewInit,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { slideInOut } from '@app/core/animations/slide-in-out';
import { NotificationTypes } from '@app/core/notifications/notification-types';
import { take, tap, timer } from 'rxjs';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [slideInOut],
})
export class NotificationComponent implements AfterViewInit {
  constructor(private destroyRef: DestroyRef) {}

  @Input({ required: true })
  type!: NotificationTypes;

  @ViewChild('dynamicContent', { read: ViewContainerRef, static: true })
  viewContainerRef!: ViewContainerRef;

  @Output()
  closeNotification = new EventEmitter<void>();

  visible: boolean = true;

  protected isRenderred = false;

  protected NotificationTypes = NotificationTypes;

  ngAfterViewInit(): void {
    timer(0)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        tap(() => {
          this.isRenderred = true;
        }),
      )
      .subscribe();
  }

  onCloseNotification(): void {
    this.isRenderred = false;
    this.closeNotification.emit();
  }

  onAnimationDone(event: AnimationEvent): void {
    if (event.fromState === 'visible' && event.toState === 'void') {
      this.closeNotification.emit();
    }
  }
}
